export default __webpack_public_path__ + "static/media/green-check-circle-fill.0b417f92.svg";